import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    viewBox="0 0 64 64"
    ref={svgRef}
    {...props}
  >
    <mask
      id="mail_svg__a"
      style={{
        maskType: "alpha",
      }}
      width={64}
      height={64}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
    >
      <path fill="currentColor" d="M0 0h64v64H0z" />
    </mask>
    <g mask="url(#mail_svg__a)">
      <path
        fill="currentColor"
        d="M10.667 53.333c-1.467 0-2.723-.522-3.767-1.566-1.044-1.045-1.567-2.3-1.567-3.767V16c0-1.467.523-2.722 1.567-3.767 1.044-1.044 2.3-1.566 3.767-1.566h42.666c1.467 0 2.723.522 3.767 1.566 1.044 1.045 1.567 2.3 1.567 3.767v32c0 1.467-.523 2.722-1.567 3.767-1.044 1.044-2.3 1.566-3.767 1.566H10.667zM32 34.2a2.802 2.802 0 001.4-.4L52.267 22c.355-.222.622-.5.8-.833a2.3 2.3 0 00.266-1.1c0-.89-.377-1.556-1.133-2-.756-.445-1.533-.423-2.333.066L32 29.333l-17.867-11.2c-.8-.489-1.577-.5-2.333-.033-.756.467-1.133 1.122-1.133 1.967 0 .444.088.833.266 1.166.178.334.445.59.8.767L30.6 33.8a2.786 2.786 0 001.4.4z"
      />
    </g>
  </Icon>
));
